// src/client/lib/serviceError.ts
//
// Extends Error so React Query / try-catch flows pick it up,
// but preserves the typed `code` from ServiceResult.err().
//
// Hook throw sites do:   if (!r.ok) throw new ServiceError(r.error);
// Screens can branch on: if (error instanceof ServiceError && error.code === 'invalid_amount')
export class ServiceError extends Error {
  public readonly code: string;
  constructor(code: string) {
    super(code);
    this.name = 'ServiceError';
    this.code = code;
  }
}
